// Module
var code = `<div on-click="@this.onClick(event)"
     class="{{.elementStyle}} {{.additionalClass}}{{#isMenuShown}} active{{/}}"
     as-tooltip="tooltip"
     style="{{>visibility}} {{#if isPosAbsolute}}position: absolute; z-index: {{zIndex}};{{>position}}{{/if}}"
     {{#.focused}} focused="" {{/}}
     {{#if !(.enabled) || !(.items.length)}} disabled="" {{/if}}>

    {{#if .useSVGView}}
        <svg>
            <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#{{icon || name}}"></use>
        </svg>
    {{else}}
        <div {{#.usePNGView}} style="height:100%; width:100%;" class="{{.selectedItem.style}} {{.updateComboBoxClass}}" {{/}}>
            {{^.usePNGView}}{{selectedItemLocalizedText}}{{/}}
        </div>
    {{/if}}

    <div class="js-combobox-right-container">
        {{#if .visibleInfoBtn}}
            <div class="js-combobox-info-button" as-tooltip="infoBtnTooltip">
                <svg>
                    <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#infotool"></use>
                </svg>
            </div>
        {{/if}}

        <div class="js-combobox-arrow-down" {{^.showArrow}} style="display: none;" {{/}}>
            <svg>
                <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#ArrowDown"></use>
            </svg>
        </div>
    </div>
</div>`;
// Exports
export default code;